import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'lg:landing-glass mx-auto mt-12 flex max-w-[1400px] flex-col gap-8 px-4 lg:mt-30 lg:flex-row lg:gap-15 lg:rounded-[60px] lg:p-10 lg:pt-15',
    title:
      'text-brand-bioderma mb-6 text-[32px] leading-[1.2] font-medium lg:mb-10 lg:text-[40px]',
    info: 'z-1 lg:min-w-[394px] xl:min-w-[482px]',
    content: '',
    image: 'overflow-hidden rounded-[20px]',
    tabs: 'scrollbar-hidden -mt-[7px] -ml-2 flex gap-3 overflow-x-scroll pb-8 pl-2 lg:pb-10 xl:gap-4',
    tab: 'group flex cursor-pointer flex-col items-center gap-1.5',
    tabImage:
      'h-[55px] w-[55px] overflow-hidden rounded-full border-[2px] border-transparent bg-[#EEEEF0] object-cover group-hover:border-[#E0457B]',
    tabName:
      'border-x-0.5 text-brand-bioderma rounded-[51px] border-y-2 border-white bg-white/5 px-4 py-1.5 text-sm shadow-[0px_5.44px_21.32px_0px_rgba(0,0,0,0.06)] backdrop-blur-md transition-colors duration-500 group-hover:bg-white/60 group-hover:text-[#E0457B] group-hover:duration-0',

    name: 'text-brand-bioderma mb-2 text-[20px] leading-[1.4] font-medium lg:text-[24px]',
    diagnosis: 'text-brand-bioderma text-[14px] leading-[1.4]',
    age: 'text-[24px] leading-[1.4] font-medium text-[#E0457B]',

    blocks: 'mt-6 flex flex-col gap-3',
    block: 'bg-blue-light rounded-[20px] px-4 py-6 lg:px-10 lg:py-7',
    blockTitle:
      'mb-3 text-[12px] leading-[1.4] font-black text-[#E0457B] uppercase',
    blockText: 'text-brand-bioderma text-[16px] leading-[1.5]',
    blockLast: 'bg-blue-light rounded-[20px] px-4 py-6 lg:px-10 lg:py-7',
    readMore:
      'text-brand-bioderma mt-5 flex cursor-pointer items-center gap-2 text-[14px] leading-[1.2] font-medium tracking-[0.06em] uppercase lg:hidden',
    readMoreIcon: 'size-4 rotate-90 transition-transform duration-200',

    imageWrapper: 'relative',
    arrows: 'absolute right-5 bottom-[34px] flex gap-8',
    arrowPrev:
      'flex-center h-12 w-12 cursor-pointer rounded-full bg-white/60 disabled:pointer-events-none disabled:opacity-60',
    arrowNext:
      'flex-center h-12 w-12 cursor-pointer rounded-full bg-white/60 disabled:pointer-events-none disabled:opacity-60'
  },
  variants: {
    isActive: {
      true: {
        tabImage: 'border-[#E0457B]',
        tabName: 'font-medium'
      }
    },
    isExpanded: {
      false: {
        blockText: 'max-lg:line-clamp-7',
        blockLast: 'max-lg:hidden'
      },
      true: {
        readMoreIcon: '-rotate-90'
      }
    }
  },
  defaultVariants: {
    isExpanded: false
  }
});
